"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.geo2zip = exports.defaultOptions = void 0;
const sphere_knn_1 = __importDefault(require("sphere-knn"));
const standardize_geolocation_1 = require("standardize-geolocation");
const array_1 = __importDefault(require("us-zips/array"));
exports.defaultOptions = { limit: 1 };
// Start building lookup when module imported
const lookup = (0, sphere_knn_1.default)(array_1.default);
// Don't recreate this function on every run
const pluckZipCode = (obj) => obj.zipCode;
function geo2zip(location, extraOptions = {}) {
    const options = { ...exports.defaultOptions, ...extraOptions };
    const { latitude, longitude } = (0, standardize_geolocation_1.standardizeGeolocation)(location);
    return new Promise((resolve) => {
        const results = lookup(latitude, longitude, options.limit);
        resolve(results.map(pluckZipCode));
    });
}
exports.geo2zip = geo2zip;
exports.default = geo2zip;
//# sourceMappingURL=index.js.map